import * as React from 'react';

import { useStyles } from './styles';

function TaxAlert() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <p>
        <strong>Atenção</strong>
      </p>
      <p>
        A cobrança do IOF ou outros encargos referentes a operadora de cartão de crédito do cliente final são de responsabilidade única e exclusivas
        dos mesmos. Não há opção de parcelamento para compras internacionais. A conversão em real exibida na tabela a cima é apenas um demonstrativo
        diário do valor cadastrado convertido em real, lembrando que em todas suas vendas o valor do produto será o valor correspondido o momento da
        compra.
      </p>
    </div>
  );
}

export { TaxAlert };
